import { GlobalEventService } from '@host/services/event.service';
import { useNotificationStore } from '@/host/stores';
import type { EventHandler } from '@host/services/event.service';

export abstract class BaseAppService {
  protected emitEvent(event: string, payload: any) {
    GlobalEventService.emit(event, payload);
  }

  protected onEvent(event: string, callback: EventHandler): void;
  protected onEvent(params: { event: string; callback: EventHandler; handle?: string }): void;

  protected onEvent(...args: any[]): void {
    if (typeof args[0] === 'string' && typeof args[1] === 'function') {
      const [event, callback] = args;
      GlobalEventService.on({ event, callback });
    } else if (typeof args[0] === 'object') {
      GlobalEventService.on(args[0]);
    } else {
      console.warn('[BaseAppService] Invalid onEvent usage', args);
    }
  }

  protected removeEvent(handle: string): void {
    GlobalEventService.remove(handle);
  }

  protected notify(severity: string, title: string, message: string) {
    useNotificationStore.getState().notify({
      severity,
      title,
      message,
    });
  }
}
